import React, { useEffect, useState } from "react";
import { DashboardHomeEnAPI, GetCSVEnAPI } from "../../action/actionCreatorsRequests";
import { Drawer, Pagination } from "antd";
import { CloseOutlined, FileExcelOutlined, PrinterOutlined } from "@ant-design/icons";
import { descargarDocPasandoBase64Generico, traducirPagina } from "../../librerias/funciones";
import CPSearch from "../Utils/CPSearch";
import { CPAnyosPeriodo } from "../CPAnyosPeriodo";

const FichaDetalleMatriculaSocio = ({ abrirFicha = false, cerrarFicha = () => { }, titulo = "", datos = {}, MES_INI = "", MES_FIN = "", ANYO = "", ID_SOCIO = "" }) => {
    const ref = React.useRef(null)

    const [registros, setRegistros] = useState([])
    const [datosPaginacion, setDatosPaginacion] = React.useState({ iniPage: 1, inicio: 1, final: 40, numPagina: 40 });
    const [textoBuscador, setTextoBuscador] = useState("")
    const [registroFecha, setRegistroFecha] = useState({
        INICIO: 0,
        FIN: 0,
        ANYO: 0
    })
    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);




    const paginarTabla = (page, pageSize) => {
        if (registros.length > 0) {
            let pInicio = (pageSize * page) - (datosPaginacion.numPagina);
            let pFinal = pageSize * page;


            setDatosPaginacion(
                {
                    iniPage: page,
                    inicio: pInicio,
                    final: pFinal,
                    numPagina: datosPaginacion.numPagina
                }
            )
        }
    }


    const updateNumberPage = (current, size) => {
        setDatosPaginacion(
            {
                iniPage: current,
                inicio: 1,
                final: size,
                numPagina: size
            }
        )
    }



    const filtroLocalRegistros = (textoAFiltrar, registros) => {
        let resultado = []
        if (textoAFiltrar !== undefined && textoAFiltrar !== "") {
            if (registros !== undefined && registros !== null && registros.length > 0) {

                let resultadoFiltro = registros.filter((item) => {
                    return item.FECHA_CONSULTA.toUpperCase().includes(textoAFiltrar.toUpperCase()) ||
                        item.MATRICULA.toUpperCase().includes(textoAFiltrar.toUpperCase()) ||
                        item.BASTIDOR.toUpperCase().includes(textoAFiltrar.toUpperCase()) ||

                        item.NOMBRE_USUARIO_PLATAFORMA.toUpperCase().includes(textoAFiltrar.toUpperCase()) ||
                        item.PLATAFORMA.toUpperCase().includes(textoAFiltrar.toUpperCase()) ||
                        item.DISPOSITIVO.toUpperCase().includes(textoAFiltrar.toUpperCase()) ||
                        item.IP_CONSULTA.toUpperCase().includes(textoAFiltrar.toUpperCase())
                })

                if (resultadoFiltro.length > 0) {
                    resultado = resultadoFiltro
                }
            }


            if (datosPaginacion.inicio !== 1) {
                datosPaginacion.inicio = 1
                setDatosPaginacion({ ...datosPaginacion })
            }
        } else {
            resultado = registros;
        }



        return resultado
    }



    const bucarRegistros = async (MES_INI, MES_FIN, ANYO, CONSULTA, ID_SOCIO, ID_PAIS) => {
        setRegistros([])

        let RESULTADOS = null
        let registros = await DashboardHomeEnAPI(MES_INI, MES_FIN, ANYO, CONSULTA, ID_SOCIO, ID_PAIS)
        if (registros !== undefined && registros !== null && registros.REGISTROS !== undefined && registros.REGISTROS !== null) {
            RESULTADOS = registros.REGISTROS;
        }

        setRegistros(RESULTADOS)

    }


    const DocumentoCSV = (LINEAS) => {
        GetCSVEnAPI(LINEAS).then((doc) => {
            if (doc !== undefined && doc.CSV !== "" && doc.CSV !== null) {
                descargarDocPasandoBase64Generico(doc.CSV, "csv")
            }
        })
    }


    const seleccionadoActual = (registros) => {
        let REGISTRO = registros.find((registro) => registro.SELECCIONADO)
        return REGISTRO === undefined ? { ID: null, DESCRIPCION: null } : REGISTRO
    }

    const obtenerMesPeriodo = (REGISTRO) => {
        return REGISTRO === 0 ? { INICIO: 1, FIN: 12 } : { INICIO: REGISTRO, FIN: REGISTRO }
    }

    const periodoMes = (REGISTROS) => {
        const MES_ACTUAL = seleccionadoActual(REGISTROS.INICIAL_MES).ID
        const { INICIO, FIN } = obtenerMesPeriodo(MES_ACTUAL)
        registroFecha.INICIO = INICIO
        registroFecha.FIN = FIN
        bucarRegistros(registroFecha.INICIO, registroFecha.FIN, registroFecha.ANYO, 11, ID_SOCIO, null)
        setRegistroFecha({ ...registroFecha })

        datosPaginacion.inicio = 1
        setDatosPaginacion({ ...datosPaginacion })
    }


    const anyoActual = (REGISTROS) => {
        const ANYO_ACTUAL = seleccionadoActual(REGISTROS.ANYOS).ID
        registroFecha.ANYO = ANYO_ACTUAL
        bucarRegistros(registroFecha.INICIO, registroFecha.FIN, registroFecha.ANYO, 11, ID_SOCIO, null)
        setRegistroFecha({ ...registroFecha })

        datosPaginacion.inicio = 1
        setDatosPaginacion({ ...datosPaginacion })
    }


    useEffect(() => {
        console.log("ref.current", ref.current)
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }

    })

    useEffect(() => {
        const fecha = new Date();
        const mesActual = fecha.getMonth() + 1;

        registroFecha.INICIO = mesActual
        registroFecha.FIN = mesActual
        registroFecha.ANYO = ANYO

        bucarRegistros(registroFecha.INICIO, registroFecha.FIN, registroFecha.ANYO, 11, ID_SOCIO, null)
        setRegistroFecha({ ...registroFecha })

    }, [])



    console.log("alturaSubmenu", alturaSubmenu, ref.current)

    return (
        <>

            <Drawer
                width={"80%"}
                /*onClose={() => { cerrarFicha(false) }}*/
                visible={abrirFicha}
                placement={"right"}
                closable={false}
                bodyStyle={{ padding: '0px' }}
                style={{ color: '#fff' }}
            >

                <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => { cerrarFicha(false) }}></CloseOutlined>
                        <div> {titulo}</div>
                    </div>
                </div>


                <div className='containerDetalleMatriculas'>

                    <div className="menu_mantenimiento" ref={ref}>
                        <div className="mantenimiento_item1">
                            <div className={`grid-container`} style={{ backgroundColor: '#fff', padding: '0px' }}>

                                <CPSearch
                                    textoBuscador={textoBuscador}
                                    onChangeInput={(e) => {
                                        let txtBuscadorLocal = e.target.value;
                                        setTextoBuscador(txtBuscadorLocal)
                                    }}
                                    onCloseInput={() => {
                                        let txtBuscadorLocal = "";
                                        setTextoBuscador(txtBuscadorLocal)
                                    }}
                                    styles={{ height: '-webkit-fill-available', border: 'none' }}
                                />

                                <button
                                    className="btn_buscador_tarifa efectoHoverGrupo"
                                    style={{ backgroundColor: '--azul-claro-serca', color: '#fff' }}
                                    onClick={() => {
                                        if (registros !== null && registros.length > 0) {
                                            DocumentoCSV(registros)
                                        }
                                    }}
                                >

                                    <FileExcelOutlined style={{ fontSize: '20px' }} />
                                    {traducirPagina("Descargar_csv")}

                                </button>

                                <CPAnyosPeriodo MES_SELECCIONADO={periodoMes} ANYO_SELECCIONADO={anyoActual} className="cp_matriculas" MES_ACTUAL={true}></CPAnyosPeriodo>

                            </div>
                        </div>

                        <div className="mantenimiento_item2" style={{ gap: '10px' }}>
                            {
                                registros !== null && registros.length > 0 && (
                                    <Pagination
                                        showSizeChanger
                                        current={datosPaginacion.iniPage}
                                        onShowSizeChange={(current, size) => { updateNumberPage(current, size) }}
                                        total={filtroLocalRegistros(textoBuscador, registros).length}
                                        showTotal={() => ` ${filtroLocalRegistros(textoBuscador, registros).length} ${"registros"}`}
                                        defaultPageSize={40}
                                        onChange={(page, pageSize) => { paginarTabla(page, pageSize) }}
                                    >

                                    </Pagination>
                                )
                            }
                        </div>
                    </div>

                    {
                        registros === null ?
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '60vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                            :
                            registros.length > 0 ?
                                <div className="containerDetalleTabla" style={{ height: `calc(100vh - ${(70 + alturaSubmenu)}px )` }}>

                                    <table className="tabla_dinamica" style={{ width: '100%', color: '#000' }}>
                                        <thead>
                                            <tr style={{ backgroundColor: 'var(--azul-claro-serca)', color: '#fff' }}>
                                                <th className={`formatear_cabecera_icono`} style={{ width: '160px' }}>Fecha de consulta</th>
                                                <th className={`formatear_cabecera_icono`} style={{ width: '100px' }}>Matrícula</th>
                                                <th className={`formatear_cabecera_icono`} style={{ width: '200px' }}>Bastidor</th>
                                                <th className={`formatear_cabecera_icono`} style={{ width: '80px' }}>Se cobro</th>
                                                <th className={`formatear_cabecera_icono`} >Nombre usuario</th>
                                                <th className={`formatear_cabecera_icono`} style={{ width: '170px' }}>Plataforma</th>
                                                <th className={`formatear_cabecera_icono`} style={{ width: '100px' }}>Correcto</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filtroLocalRegistros(textoBuscador, registros).map((item, i) =>
                                                (i + 1) >= datosPaginacion.inicio && (i + 1) <= datosPaginacion.final && (
                                                    <tr>
                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{item.FECHA_CONSULTA}</td>
                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{item.MATRICULA}</td>
                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{item.BASTIDOR}</td>
                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{item.COBRO ? "SI" : "NO"}</td>
                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{item.NOMBRE_USUARIO_PLATAFORMA}</td>
                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{item.PLATAFORMA}</td>
                                                        <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}>{item.OK ? "SI" : "NO"}</td>

                                                    </tr>
                                                )
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '60vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>

                    }
                </div>
            </Drawer>
        </>
    )

}

export default FichaDetalleMatriculaSocio;
